import { inject, Injectable } from "@angular/core";
import {
  FlameBottomSheetService,
  FlameTemplateModalOverlayRef,
} from "@ngx-mxflame/atoms/bottom-sheet";
import { TaggingService } from "../tagging.service";
import { concatMap, Subject } from "rxjs";
import Hammer from "hammerjs";

@Injectable({
  providedIn: "root",
})
export class BottomSheetService {
  #ref: FlameTemplateModalOverlayRef;

  readonly #bottomSheet = inject(FlameBottomSheetService);

  #taggingService = inject(TaggingService);

  #task = new Subject<{ component: any; data?: any }>();

  constructor() {
    this.#task
      .pipe(concatMap(({ component, data }) => this.#process(component, data)))
      .subscribe();
  }

  show(component: any, data?: any): void {
    this.#task.next({ component, data });
    // this.#process(component, data);
  }

  #process(_component: any, _data?: any): Promise<void> {
    return new Promise((_resolve) => {
      this.#ref = this.#bottomSheet.open(_component, {
        titlePosition: "center",
        closeBackdropClick: true,
        ..._data?.config,
      });
      this.#ref.componentInstance.dialogDirective.data = _data;
      this._swipeDown();
      this.#ref.afterClosed().subscribe((value) => {
        try {
          this.#taggingService.getError(
            value,
            this.#ref.componentInstance.dialogDirective.data
          );
          this.#ref = null;
          _data?.close();
          _resolve();
        } catch (error) {
          this.#ref = null;
          _resolve();
        }
      });
    });
  }

  private _swipeDown() {
    const refElementFlame = document.getElementsByClassName("fl-bottom-sheet");
    if (refElementFlame.length === 0) {
      return;
    }
    const element = refElementFlame[0] as HTMLElement;
    const hammer = new Hammer(element);
    hammer.get('swipe').set({ direction: Hammer.DIRECTION_DOWN });
    hammer.on('swipe', (event) => {
      if (event.direction === Hammer.DIRECTION_DOWN) {
        this.hide();
      }
    });
  }

  public hide(): void {
    if (!this.#ref) {
      return;
    }
    this.#ref.close(true);
  }
}
